import { Pipe, PipeTransform } from '@angular/core';
import { DealStatusesState } from 'app/store/deal/statuses/deal-statuses.state';
import { Store } from '@ngxs/store';

@Pipe({
  name: 'dealStatusDisplay',
  standalone: true,
})
export class DealStatusDisplayPipe implements PipeTransform {
  constructor(private store: Store) {}

  transform(statusString: string): string {
    return this.store.selectSnapshot(
      DealStatusesState.displayName(statusString)
    );
  }
}
